import React from 'react';
import { usePRContextSelector, usePRDispatch } from './ProductReceipts.context';
import { RouteComponentProps } from 'react-router';
import { IKitDetail } from 'api/swaggerTypes';

export enum ProductReceiptsAPIType {
    deleteGridLine = 'deleteGridLine',
    updateGridLine = 'updateGridLine',
    updateLine = 'updateLine',
}

export const useTabLocations = (url: string, location: RouteComponentProps['location']) => {

    const contextDispatch = usePRDispatch();
    const selectedContextProductReceipt = usePRContextSelector<'ProductReceipt'>((state) => state.ProductReceipt);
    const PRLineNumber = usePRContextSelector<'LineNumber'>((state) => state.LineNumber);
    const ProductReceipt = selectedContextProductReceipt;

    const tabLocations = React.useMemo(
        () => {

            return ({
                Lines: {
                    pathname: url,
                    search: `?ProductReceipt=${ProductReceipt ?? ''}`
                },
                ProductReceiptDetails: {
                    pathname: `${url.endsWith('/') ? url : `${url}/`}product-receipt-details`,
                    search: `?ProductReceipt=${ProductReceipt ?? ''}`
                },
                LineDetails: {
                    pathname: `${url.endsWith('/') ? url : `${url}/`}line-details`,
                    search: `?ProductReceipt=${ProductReceipt ?? ''}`
                },
                FreightChargeDetails: {
                    pathname: `${url.endsWith('/') ? url : `${url}/`}freight-charge-details`,
                    search: `?ProductReceipt=${ProductReceipt}`
                },
            });
        },
        [url, ProductReceipt, PRLineNumber]
    );

    React.useEffect(
        () => {
            const params = (new URLSearchParams(location.search));
            const ProductReceiptParam = params.get('ProductReceipt');
            const LineNumberParam = params.get('LineNumber') || '';

            contextDispatch({
                setProductReceipt: Number(ProductReceiptParam),
                setLineNumber: Number(LineNumberParam),
            });
        },
        [contextDispatch]
    );

    return {
        tabLocations
    };
};

type BomApis = 'addLine' | 'calculateFastEntry' | 'updateGridLine' | 'calculateGridLine' | 'update' | 'load';

export const usePriceOverrideAndKitValidations = () => {
    const [multipleBomOpen, setMultipleBomState] = React.useState<boolean>(false);
    const [bomList, setBomList] = React.useState<IKitDetail[]>([]);
    const [kitStatus, setKitStatus] = React.useState<string>('');
    const [selectedBomCode, setSelectedBomCode] = React.useState<string>('');
    const [multipleBomDialogApi, setMultipleBomDialogApi] = React.useState<BomApis>(null);

    const resetStates = () => {
        setMultipleBomState(false);
        setBomList([]);
        setKitStatus('');
        setSelectedBomCode('');
        setMultipleBomDialogApi(null);
    };

    const validate = (response: any) => {
        if (!response.Forms) {
            return;
        }
        const form = response.Forms?.[0];

        if (form?.FormId === 'SelectBomCode') {
            setBomList((response?.KitDetail) ?? [] as any);
            setKitStatus((response?.KitStatus) ?? '');
            setSelectedBomCode((response?.BomCode) ?? '');
            setMultipleBomDialogApi(response?.multipleBomDialogApi ?? null);
            setMultipleBomState(true);
        }
    };

    return {
        bomList,
        kitStatus,
        selectedBomCode,
        multipleBomOpen,
        multipleBomDialogApi,
        resetStates,
        setMultipleBomDialogApi,
        validate,
        setBomList,
        setKitStatus,
        setSelectedBomCode,
        setMultipleBomState
    };
};
